/* global console */

import MiscUtils, { DEV_STAGE } from './MiscUtils'

const Logger = {

  info: (message, args) => {
    if (MiscUtils.STAGE === DEV_STAGE) {
      if (args) {
        console.log(message, args)
      }
      else {
        console.log(message)
      }
    }
  },

  error: (message, error) => {
    if (MiscUtils.STAGE === DEV_STAGE) {
      console.error(message, error)
    }
  }

}

export default Logger



// WEBPACK FOOTER //
// ./src/infra/Logger.js